import { gql } from '@/apollo'

export const GET_LOGIN_ATTEMPTS = gql`
  query GetLoginAttempts($pagination: PaginationInput, $filter: LoginAttemptsFilter) {
    loginAttempts(pagination: $pagination, filter: $filter) {
      nodes {
        id
        userId
        user {
          id
          username
          email
          firstName
          lastName
        }
        email
        success
        ipAddress
        userAgent
        failureCode
        timestamp
        sessionId
        location
        method
      }
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
`

export const GET_USER_ACTION_LOGS = gql`
  query GetUserActionLogs($pagination: PaginationInput, $filter: LogsFilter) {
    auditLogs(pagination: $pagination, filter: $filter) {
      nodes {
        id
        userId
        user {
          id
          username
          email
          firstName
          lastName
        }
        action
        resource
        resourceId
        details
        ipAddress
        userAgent
        timestamp
        level
        category
        success
        errorCode
        duration
      }
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
`

export const GET_BULLETIN_LOGS = gql`
  query GetBulletinLogs($pagination: PaginationInput) {
    bulletinLogs(pagination: $pagination) {
      nodes {
        id
        userId
        user {
          id
          username
          email
          firstName
          lastName
        }
        action
        resource
        resourceId
        details
        timestamp
        success
      }
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
`

export const GET_PROVIDER_LOGS = gql`
  query GetProviderLogs($pagination: PaginationInput) {
    providerLogs(pagination: $pagination) {
      nodes {
        id
        userId
        user {
          id
          username
          email
          firstName
          lastName
        }
        action
        resource
        resourceId
        details
        timestamp
        success
      }
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
`

export const GET_LOCATION_LOGS = gql`
  query GetLocationLogs($pagination: PaginationInput) {
    locationLogs(pagination: $pagination) {
      nodes {
        id
        userId
        user {
          id
          username
          email
          firstName
          lastName
        }
        action
        resource
        resourceId
        details
        timestamp
        success
      }
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
`

export const GET_INSURANCE_LOGS = gql`
  query GetInsuranceLogs($pagination: PaginationInput) {
    insuranceLogs(pagination: $pagination) {
      nodes {
        id
        userId
        user {
          id
          username
          email
          firstName
          lastName
        }
        action
        resource
        resourceId
        details
        timestamp
        success
      }
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
`

export const GET_CONDITION_LOGS = gql`
  query GetConditionLogs($pagination: PaginationInput) {
    conditionLogs(pagination: $pagination) {
      nodes {
        id
        userId
        user {
          id
          username
          email
          firstName
          lastName
        }
        action
        resource
        resourceId
        details
        timestamp
        success
      }
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
`

export const GET_SYSTEM_LOGS = gql`
  query GetSystemLogs($pagination: PaginationInput, $filter: SystemLogsFilter) {
    systemLogs(pagination: $pagination, filter: $filter) {
      nodes {
        id
        level
        category
        message
        details
        source
        timestamp
        errorCode
        stackTrace
        metadata
      }
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
`

export const GET_ERROR_LOGS = gql`
  query GetErrorLogs($pagination: PaginationInput, $filter: SystemLogsFilter) {
    errorLogs(pagination: $pagination, filter: $filter) {
      nodes {
        id
        level
        category
        message
        details
        source
        timestamp
        errorCode
        stackTrace
        metadata
      }
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
`

export const GET_LOGIN_STATS = gql`
  query GetLoginStats {
    loginStats {
      total
      successful
      failed
      lastHour
      lastDay
      lastWeek
    }
  }
`

export const GET_USER_ACTION_STATS = gql`
  query GetUserActionStats {
    userActionStats {
      total
      successful
      failed
      lastHour
      lastDay
      lastWeek
    }
  }
`

export const EXPORT_LOGS = gql`
  mutation ExportLogs($type: String!, $filter: LogsFilter) {
    exportLogs(type: $type, filter: $filter)
  }
`

export const CLEAR_OLD_LOGS = gql`
  mutation ClearOldLogs($olderThanDays: Int!, $category: LogCategory) {
    clearOldLogs(olderThanDays: $olderThanDays, category: $category)
  }
`

export const GET_BLOCKED_EVENTS = gql`
  query GetBlockedEvents($pagination: PaginationInput, $filter: LogsFilter) {
    auditLogs(pagination: $pagination, filter: $filter) {
      nodes {
        id
        userId
        user {
          id
          username
          email
          firstName
          lastName
        }
        action
        resource
        resourceId
        details
        ipAddress
        userAgent
        timestamp
        level
        category
        success
        errorCode
        duration
      }
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
`
